import React from 'react';
import PropTypes from 'prop-types';
/* helpers */
import { sortItemsByPropertyName } from '../../utils/info-helper';
import { httpRequest } from '../../utils/xml-request-helper';
/* Components */
import TableHeadCell from '../../components/table-head-cell/table-head-cell';
import EmptyContent from '../../components/empty-content/empty-content';
import Menu, { MenuItem } from '../../components/menu/menu';
import Modal from '../../components/modal/modal';
import ScrollArea from '../../components/scroll-area/scroll-area';
/* styles */
import './scopes.scss';

const tableColumns = [
    { title: 'Scope Id', prop: 'scopeId', width: 10, sortable: true },
    { title: 'Name', prop: 'scopeName', sortable: true }
];

class ScopesPage extends React.PureComponent {
    state = {
        sortedScopes: [...this.props.scopes],
        isDeleteModalVisible: false,
        deleteScopeId: null,
        sortProp: '',
        sortOrder: 'ASC'
    };

    setSortProp = (prop) => {
        let sortProp = this.state.sortProp;
        let sortOrder = this.state.sortOrder;
        if (prop === this.state.sortProp) {
            sortOrder = this.state.sortOrder === 'ASC' ? 'DESC' : 'ASC';
        } else {
            sortProp = prop;
            sortOrder = 'ASC';
        }
        const sortedScopes = this.props.scopes.slice().sort(sortItemsByPropertyName(sortProp, sortOrder === 'ASC'));
        this.setState({ sortProp, sortOrder, sortedScopes });
    };

    handleDelete = (scopeId) => {
        this.setState({ isDeleteModalVisible: true, deleteScopeId: scopeId });
    };

    handleDeleteConfirm = () => {
        httpRequest({
            method: 'DELETE',
            url: `/Scopes/Delete/${this.state.deleteScopeId}`,
            onSuccess: () => window.location.reload()
        });
        this.handleDeleteCancel();
    };

    handleDeleteCancel = () => {
        this.setState({ isDeleteModalVisible: false, deleteScopeId: null });
    };

    renderCellValue = (col, value) => {
        if (!value[col.prop]) {
            return '-';
        }
        return value[col.prop];
    };

    renderMenu = (scope) => (
        <Menu menuRight>
            <MenuItem linkTo={`/scopes/edit/?name=${scope.scopeName}`} icon="icon-edit">
                Edit
            </MenuItem>
            <MenuItem onClick={this.handleDelete.bind(this, scope.scopeId)} icon="icon-delete">
                Delete
            </MenuItem>
        </Menu>
    );

    render() {
        const { sortProp, sortOrder, sortedScopes } = this.state;
        return (
            <div className="sten-content sten-scopes-page">
                <Modal.Delete
                    isOpen={this.state.isDeleteModalVisible}
                    onDelete={this.handleDeleteConfirm}
                    onCancel={this.handleDeleteCancel}
                >
                    Are you sure you want to delete this Scope?
                </Modal.Delete>
                <div className="sten-content__header">
                    <h1 className="sten-content__title text-uppercase">Scopes</h1>
                </div>
                <ScrollArea className="sten-content__body">
                    <section className="sten-content__section">
                        <div className="sten-panel col-lg-12 col-md-18 col-xs-24">
                            <div className="sten-panel__header flex">
                                <div className="flex-grow">
                                    <div className="flex-row flex-center">
                                        <div className="flex-grow">
                                            <h3 className="sten-panel__title">Scopes</h3>
                                        </div>
                                        <div className="flex-shrink">
                                            <a href="/scopes/create">
                                                <span className="btn__icon icon icon-plus" />
                                                Add Scope
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="sten-panel__body">
                                {sortedScopes.length > 0 ? (
                                    <table className="sten-table sten-table--sm">
                                        <thead>
                                            <tr>
                                                {tableColumns.map((col, index) => (
                                                    <TableHeadCell
                                                        style={{ width: `${col.width}rem` }}
                                                        sortOrder={sortProp === col.prop ? sortOrder : ''}
                                                        sortable={col.sortable}
                                                        /* eslint-disable-next-line react/no-array-index-key */
                                                        key={index}
                                                        onClick={this.setSortProp.bind(this, col.prop)}
                                                    >
                                                        {col.title}
                                                    </TableHeadCell>
                                                ))}
                                                <th style={{ width: '4rem' }} />
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {sortedScopes.map((scope) => (
                                                <tr key={scope.scopeId}>
                                                    {tableColumns.map((col, index) => (
                                                        /* eslint-disable-next-line react/no-array-index-key */
                                                        <td key={index} className={col.className}>
                                                            {this.renderCellValue(col, scope)}
                                                        </td>
                                                    ))}
                                                    <td>{this.renderMenu(scope)}</td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                ) : (
                                    <EmptyContent />
                                )}
                            </div>
                        </div>
                    </section>
                </ScrollArea>
                <input type="hidden" name="__RequestVerificationToken" value={this.props.token} />
            </div>
        );
    }
}

ScopesPage.propTypes = {
    token: PropTypes.string.isRequired,
    scopes: PropTypes.arrayOf(PropTypes.object).isRequired
};

export default ScopesPage;
